import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import bootstrapCss from 'bootstrap/dist/css/bootstrap.min.css';

// import Loader from './Loader';
import LandingContainer from './LandingContainer';
import Features from './Features';
import Video from './Video';
import Services from './Services';
// import Portfolio from './Portfolio';
import Team from './Team';
import News from './News';
import Partners from './Partners';
// import Footer from '../homeV2/Footer'
import s from './Home.css';
import UnderMaintenance from '../../components/Layout/UnderMaintenance';

class Home extends React.Component {
  render() {
    const { underMaintenance, isLoggedIn, user } = this.props;

    // if (underMaintenance) {
    //   return (
    //     <UnderMaintenance styles={s} isLoggedIn={isLoggedIn} user={user} />
    //   );
    // }
    return (
      <div className={s.container}>
        <LandingContainer styles={s} />
        <Features styles={s} />
        <Video styles={s} />
        <Services styles={s} />
        {/* <Team styles={s} /> */}

      {/*  <News styles={s} /> */}
        <hr className={s.myHr} />
      {/*  <Footer /> */}
      {/*  <Partners styles={s} /> */}
      </div>
    );
  }
}

export default withStyles(bootstrapCss, s)(Home);



// WEBPACK FOOTER //
// ./src/routes/home/Home.js